export default __webpack_public_path__ + "static/media/icon_start.04751d75.svg";